import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Modal, ModalHeader, ModalTitle, ModalClose, ModalBody} from 'react-modal-bootstrap';
import ContactPersonFormRedux from "./ContactPersonFormRedux";
import * as contactPersonModalActions from '../../actions/contactPersonModalActions';
import * as contactPersonListActions from '../../actions/contactPersonListActions';
import * as roles from '../../services/access/roles';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

class ContactPersonModal extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }

    submit(formFields) {
        let params = Object.assign({}, formFields);
        params.contactPerson = 1;
        params.companyId = this.props.user.company.id;
        params.roles = [roles.PARTNER_ROLE];

        this.props.actions.createContactPerson(params).then(() => {
            this.props.actions.hideContactPersonModal();
        });
    }

    hideModal() {
        this.props.actions.hideContactPersonModal();
    }

    render() {
        return (
            <Modal className="contact-person-modal" isOpen={this.props.showContactPersonModal} onRequestHide={this.hideModal}>
                <ModalHeader>
                    <ModalTitle>{this.props.intl.formatMessage(messages.contactPersonCreate)}</ModalTitle>
                    <ModalClose onClick={this.hideModal}/>
                </ModalHeader>
                <ModalBody>
                    <ContactPersonFormRedux
                        initialValues={this.props.contactPerson}
                        onSubmit={this.submit}
                        isModal = {true}
                    />
                </ModalBody>
            </Modal>
        );
    }

}

function mapStateToProps(state, ownProps) {

    let contactPerson = Object.assign({}, state.contactPerson);

    return {
        showContactPersonModal: state.showContactPersonModal,
        contactPerson: contactPerson,
        user: state.user,
    };
}

function mapDispatchToProps(dispatch) {


    return {
        actions: bindActionCreators(Object.assign(
            {},
            contactPersonListActions,
            contactPersonModalActions
        ), dispatch)
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ContactPersonModal));


// WEBPACK FOOTER //
// ./web/src/components/contact-person/ContactPersonModal.jsx